export class ReferenceSource {
    id: number;
    name: string;
}